import React, { useEffect } from 'react';
import './AdBanner.css';

function AdBanner({ 
  subscriptionInfo, 
  adType = 'banner', 
  adId = 'ad-banner-1',
  className = '',
  showUpgradePrompt = false,
  onUpgradeClick 
}) {
  useEffect(() => {
    // Initialize Google AdSense when component mounts
    try {
      if (window.adsbygoogle && window.adsbygoogle.length === 0) {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      }
    } catch (error) {
      console.log('AdSense not loaded yet');
    }
  }, []);

  // Don't show ads for Pro users
  if (subscriptionInfo?.isPro) {
    return null;
  }

  if (adType === 'enhancement-interstitial') {
    return (
      <div className={`ad-interstitial ${className}`}>
        <div className="ad-content">
          <div className="ad-header">
            <span className="ad-label">Advertisement</span>
            {showUpgradePrompt && (
              <button className="ad-upgrade-btn" onClick={onUpgradeClick}>
                Remove Ads - Go Pro
              </button>
            )}
          </div>
          
          {/* Google AdSense Ad */}
          <ins className="adsbygoogle ad-display-block"
               style={{display: 'block'}}
               data-ad-client="ca-pub-YOUR_ADSENSE_ID_HERE"
               data-ad-slot="YOUR_AD_SLOT_ID_HERE"
               data-ad-format="auto"
               data-full-width-responsive="true">
          </ins>
          
          {/* Fallback ad placeholder for development */}
          <div className="ad-placeholder">
            <div className="ad-placeholder-content">
              <h3>🚀 Upgrade to Pro</h3>
              <p>Remove ads and unlock unlimited AI enhancements!</p>
              <div className="ad-placeholder-benefits">
                <span>✨ No ads</span>
                <span>🔥 Unlimited notes</span>
                <span>🤖 Advanced AI</span>
              </div>
            </div>
          </div>
        </div>
        
        <div className="ad-continue">
          <p>Your enhanced note will appear in a moment...</p>
          <div className="ad-loading-dots">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </div>
    );
  }

  // Regular banner ad
  return (
    <div className={`ad-banner ${className}`}>
      <div className="ad-header">
        <span className="ad-label">Advertisement</span>
        {showUpgradePrompt && (
          <button className="ad-upgrade-btn" onClick={onUpgradeClick}>
            Remove Ads
          </button>
        )}
      </div>
      
      {/* Google AdSense Ad */}
      <ins className="adsbygoogle"
           style={{display: 'block'}}
           data-ad-client="ca-pub-YOUR_ADSENSE_ID_HERE"
           data-ad-slot="YOUR_AD_SLOT_ID_HERE"
           data-ad-format="auto"
           data-full-width-responsive="true">
      </ins>
      
      {/* Fallback ad placeholder */}
      <div className="ad-placeholder small">
        <p>📢 Your ad here - <button onClick={onUpgradeClick}>Remove with Pro</button></p>
      </div>
    </div>
  );
}

export default AdBanner;